import { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';

import { faXmark } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import DefaultLayout from '../Layouts/DefaultLayout';

import ImagesList from '../Components/ImagesList';
import ProductTitle from '../Components/ProductTitle';

function App() {
    const [product, setProduct] = useState({});
    const [loading, setLoading] = useState(true);
    const [selectedItems, setSelectedItems] = useState([]);
    const [isSelecting, setIsSelecting] = useState(false);

    const navigate = useNavigate();
    const { tipo, slug, grupo } = useParams();
    const accessToken = localStorage.getItem('access_token');
    const baseUrl = process.env.REACT_APP_API_URL;

    useEffect(() => {
        const fetchProduct = async () => {
            let redirected = false;

            try {
                const response = await fetch(`${baseUrl}/painel/produtos/${tipo}/${slug}/imagens?grupo=${grupo}`, {
                    method: 'GET',
                    headers: {
                        Authorization: `Bearer ${accessToken}`,
                    },
                });

                if (!response.ok) {
                    if (response.status === 404) {
                        navigate('/painel/', {
                            state: {
                                message: { type: 'error', text: 'Produto não encontrado!' },
                            },
                        });
                        redirected = true;
                        return;
                    }
                    throw new Error('Erro ao buscar o produto.');
                }

                const data = await response.json();
                setProduct(data.produto);
            } catch (error) {
                console.error('Erro na requisição de conteúdo', error);
            } finally {
                if (!redirected) {
                    setLoading(false);
                }
            }
        };

        fetchProduct();
    }, []);

    useEffect(() => {
        if (product.grupos && product.grupos.length === 0) {
            navigate(`/painel/produtos/${tipo}/${slug}`, {
                state: {
                    message: { type: 'error', text: 'Grupo não encontrado!' },
                },
            });
        }
    }, [product, loading]);

    const toggleSelectingMode = () => {
        setIsSelecting(!isSelecting);

        if (isSelecting) {
            setSelectedItems([]);
        }
    };

    const handleSelection = (id) => {
        setSelectedItems((prevSelectedItems) => {
            if (prevSelectedItems.includes(id)) {
                return prevSelectedItems.filter((item) => item !== id);
            }
            return [...prevSelectedItems, id];
        });
    };

    const handleDownload = async (e) => {
        e.preventDefault();

        if (selectedItems.length === 0) {
            return;
        }

        try {
            const selectedIds = selectedItems.join(',');
            const response = await fetch(`${baseUrl}/painel/materiais/${slug}/imagens/${selectedItems}/download`, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (!response.ok) {
                throw new Error(`Erro ao baixar arquivo: ${response.statusText}`);
            }

            const blob = await response.blob();

            let fileName = product.nome;
            const contentDisposition = response.headers.get('Content-Disposition');
            console.log(contentDisposition);

            if (contentDisposition) {
                const match = contentDisposition.match(/filename="?([^"]+)"?/);
                if (match && match[1]) {
                    fileName = match[1];
                }
            }

            const url = window.URL.createObjectURL(blob);
            const a = document.createElement('a');
            a.href = url;
            a.download = fileName;
            document.body.appendChild(a);
            a.click();

            document.body.removeChild(a);
            window.URL.revokeObjectURL(url);
        } catch (error) {
            console.error('Erro na requisição:', error);
        }
    };

    return (
        <DefaultLayout>
            <div className="pb-4 md:pb-6 2xl:pb-10">
                <div className="grid grid-cols-12 gap-4 md:gap-6">
                    <div className="col-span-12">
                        <ProductTitle
                            productName="Imagens"
                            loading={loading}
                            breadcrumb={[
                                { label: 'Produtos', link: `/painel/produtos/${product.tipo_slug}/` },
                                { label: product.nome, link: `/painel/produtos/${product.tipo_slug}/${product.slug}/` },
                                { label: 'Imagens' },
                            ]}
                            back={`/painel/produtos/${product.tipo_slug}/${product.slug}`}
                        />

                        <div
                            className={`bg-quaternary flex items-center justify-end rounded-xl h-12 md:h-14 px-4 md:px-10${!loading ? ' -mt-10 ' : ' '}text-white max-lg:mt-4`}
                        >
                            <button onClick={toggleSelectingMode} className="">
                                {isSelecting ? (
                                    <FontAwesomeIcon icon={faXmark} className="text-xl -mb-px" />
                                ) : (
                                    <span className="text-sm text-light underline">Selecionar itens</span>
                                )}
                            </button>

                            {isSelecting && (
                                <>
                                    <span className="ml-2 text-sm text-light">{selectedItems.length} selecionados</span>
                                    <span className="mx-4 md:mx-7 text-sm text-light">|</span>
                                    <button onClick={handleDownload} className="flex items-center gap-2">
                                        <svg
                                            xmlns="http://www.w3.org/2000/svg"
                                            width="18"
                                            height="14.4"
                                            viewBox="0 0 18 14.4"
                                            className="fill-white"
                                        >
                                            <g transform="translate(-1.8 -3.6)">
                                                <path d="M10.8,14.4l3.6-4.5H11.7V3.6H9.9V9.9H7.2Z" />
                                                <path d="M18,16.2H3.6V9.9H1.8v6.3A1.8,1.8,0,0,0,3.6,18H18a1.8,1.8,0,0,0,1.8-1.8V9.9H18Z" />
                                            </g>
                                        </svg>
                                        <span className="text-sm text-light underline">Baixar selecionados</span>
                                    </button>
                                </>
                            )}
                        </div>

                        <ImagesList
                            content={product.grupos && product.grupos.length > 0 && product.grupos[0].imagens}
                            isCarousel={false}
                            loading={loading}
                            handleSelection={handleSelection}
                            selectedItems={selectedItems}
                            showSelectButton={isSelecting}
                        />
                    </div>
                </div>
            </div>
        </DefaultLayout>
    );
}

export default App;
